export default __webpack_public_path__ + "static/media/background.e0cde4c6.png";